import { render, staticRenderFns } from "./EmblavementsView.vue?vue&type=template&id=33a910f3"
import script from "./EmblavementsView.vue?vue&type=script&lang=js"
export * from "./EmblavementsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports